export const HOME = '/';
export const LOGIN = '/login';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';

export const TOURNAMENT = (tournament_uid) => '/tournaments/' + tournament_uid;
export const TOURNAMENT_TEAM = (tournament_uid, team_uid) => '/tournaments/' + tournament_uid + "/team/" + team_uid;

// ADMIN
export const USER_TOURNAMENTS = (user_uid) => '/user/' + user_uid;
